import { toast, ToastOptions, ToastPosition } from "react-toastify";
import { GraphQLError } from "graphql";

interface ToastProps {
  message?: string | readonly GraphQLError[] | JSX.Element | undefined;
  type?: "success" | "error" | "warning" | "info" | undefined;
  id?: string | number;
  onCloseCallback?: () => void;
  onOpenCallback?: () => void;
  autoClose?: number;
  position?: ToastPosition;
}

function showToast({
  message,
  type,
  id,
  onCloseCallback,
  onOpenCallback,
  autoClose = 2000,
  position = "top-center",
}: ToastProps) {
  const toastOptions: ToastOptions = {
    position,
    autoClose,
    toastId: id,
    onClose: onCloseCallback,
    onOpen: onOpenCallback,
  };

  switch (type) {
    case "success":
      toast.success(message || "Success!", toastOptions);
      break;
    case "error":
      toast.error(
        message || "There was an error, please try again",
        toastOptions
      );
      break;
    case "warning":
      toast.warning(message || "Warning!", toastOptions);
      break;
    default:
      toast.info(message || "Info!", toastOptions);
      break;
  }
}

export { showToast };
